import { render } from "./NewLoyerItem.vue?vue&type=template&id=60703f81"
import script from "./NewLoyerItem.vue?vue&type=script&lang=js"
export * from "./NewLoyerItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__